import { useCurrency } from "@/contexts/CurrencyContext";

export default function CurrencyToggle({ className = "" }) {
  const { currency, setCurrency } = useCurrency();
  return (
    <div
      data-testid="currency-toggle"
      className={`inline-flex items-center border border-white/15 ${className}`}
    >
      {["INR", "USD"].map((c) => (
        <button
          key={c}
          type="button"
          onClick={() => setCurrency(c)}
          data-testid={`currency-${c.toLowerCase()}`}
          className={`px-3 py-1.5 text-[10px] tracking-[0.3em] uppercase transition-all duration-300 ${
            currency === c ? "bg-white text-black" : "text-white/65 hover:text-white"
          }`}
        >
          {c === "INR" ? "₹ INR" : "$ USD"}
        </button>
      ))}
    </div>
  );
}
